import React, { useState } from 'react'
import ActionButton from '../../common/input-fields/ActionButton';
import { FieldVariants, fileUploadbtnToastMessages, uploadFileTypes } from '../../common/input-fields/utils/appInputenum';
import { toast } from 'react-toastify';
import { validationToastMessages } from '../../utils/toastMessages';
import secureLocalStorage from 'react-secure-storage';
import { postDocuemntforOCR } from '../services/services';
import WaitingLoaderAI from '../popups/WaitingLoaderAI';
import AddIcon from '@mui/icons-material/Add';
import FileUploadBtn from '../../common/input-fields/FileUploadBtn';
import { useNavigate } from 'react-router-dom';
import { startAnalysis } from '../../services/services';

const CreateInvestmentConcept = () => {

  //#region variables
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [documentDetails, setDocumentDetails] = useState({
    document: '',
    userPrompt: '',
    selectedPrompts: [],
    extarctedFields: [],
    selectedTemplate: '',
  });

  const [aiGeneratedDetails, setAIGeneratedDetails] = useState();

  //#region click events
  const handleFileUpload = (name, file) => {
    if (file) {
      const formData = new FormData();
      formData.append(name, file, file.name);
      handleChange(name, file);
    }
    else {
      handleChange(name, '');
    }
  }

  const handleChange = (name, value) => {
    setDocumentDetails((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  }

  //#region click events
  const handleCreateClick = () => {
    /* navigate('/analysis-report'); */
    if(documentDetails.document === ''){
      toast.warning(validationToastMessages.UPLOAD_FILE, {
          position: "top-right",
          theme: "colored",
      });
    }
    else{
      handleUploadDocument();
    }
  };

  //#region api post calls
  const handleUploadDocument = async(file) => {
    setLoading(true);
    const requestedData = {
      document: documentDetails.document,
    };
    const formData = new FormData();
    const userId = secureLocalStorage.getItem('userId');
    formData.append('fileToAnalyse', requestedData.document);
    const response = await startAnalysis(2,formData);
    if (response.status === 200) {
      setLoading(false);
      secureLocalStorage.setItem("documentId", response?.data?.docAnalysisID);
      navigate(`/analysis-report`);
    } else {
      setLoading(false);
      toast.error(fileUploadbtnToastMessages.FILE_UPLOAD_FAILED, {
        position: "top-right",
        theme: "colored",
      });
    }
  }

  //#region return
  return (
    <>
      <div className='display-center'>
        <FileUploadBtn 
              label="Upload Document"
              name="document"
              defaultFile={documentDetails.document}
              fileType={uploadFileTypes.Documents}
              onChange={(name,value) => handleFileUpload(name,value)} />
      </div>
      <div className='display-center margin-top-20'>
        <ActionButton
          variant={FieldVariants.OUTLINED}
          icon={<AddIcon />}
          onClick={handleCreateClick}
          label='Create Investment Concept' />
      </div>
      {
        loading &&
        <WaitingLoaderAI open={loading}/>
      }
    </>
  )
}

export default CreateInvestmentConcept